module.exports = __webpack_public_path__ + "img/president_message_sc.6c2ef24.jpg";